import BaseAPIService from './Base';

export default class RolesAPIService extends BaseAPIService {
  getRoles = async () => {
    return this.request('api/permissions/roles').then((data) => {
      return data;
    });
  };
}
